// import { BrowserRouter } from 'react-router-dom';
import { start } from '@jutro/app';
import { initDefaultGA, initDefaultMixpanel } from '@jutro/events';
import { LocaleService } from 'gw-portals-i18n-react';

import CustomTheme from './themes/clientTheme/config';
// eslint-disable-next-line import/no-unresolved
import appConfig from 'app-config';

import 'regenerator-runtime';

import App from './app/App';

const { trackingConfig = {}, authentication = {} } = appConfig;

const gaTrackingId = trackingConfig.GA_TRACKING_ID;
const mixpanelTrackingId = trackingConfig.MIXPANEL_TRACKING_ID;

if (gaTrackingId) {
    initDefaultGA(trackingConfig);
}
if (mixpanelTrackingId) {
    initDefaultMixpanel(trackingConfig);
}

let cloudAuthConfig = {};
if (authentication.authServer === 'okta') {
    cloudAuthConfig = authentication.servers.okta;
}

start(App, {
    rootId: 'root',
    messageLoader: LocaleService.loadMessages,
    coreMessageLoader: LocaleService.loadCoreMessages,
    config: [cloudAuthConfig],
    refreshOnLocaleChange: true,
    routerBasename: '/account-management',
    onInit: () => {
        LocaleService.register();
    },
    appName: {
        id: 'portal.appName',
        defaultMessage: 'Ayr Farmers Mutual Insurance Company' //CustomerEngage Account Management
    },
    appDescription: 'Description', // ToDo
    modalProvider: 'default', // ToDo
    themeConfig: CustomTheme,
});
